import { cn } from '@/utils/tailwind';

interface SessionTabsProps {
  allColumnIds: string[];
  titles: (string | undefined)[];
  activeSection: string;
  onTabClick: (columnId: string) => void;
}

export function SessionTabs({
  allColumnIds,
  titles,
  activeSection,
  onTabClick,
}: SessionTabsProps) {
  return (
    <div className="flex border-secondary px-1.5 pt-3">
      {allColumnIds.map((columnId, idx) => {
        const title = titles[idx];
        const selected = activeSection === columnId;

        return (
          <button
            type="button"
            key={columnId}
            onClick={() => onTabClick(columnId)}
            className={cn(
              '-mb-px max-w-[250px] border-b-2 border-b-transparent px-2 pb-[10px] font-semibold leading-none focus:outline-none',
              selected &&
                'border-black text-black dark:border-white dark:text-white'
            )}
          >
            <span className="line-clamp-1 whitespace-normal break-words break-all">
              {title}
            </span>
          </button>
        );
      })}
    </div>
  );
}
